import {
  USER_ID_TODO_FAIL,
  USER_ID_TODO_REQUEST,
  USER_ID_TODO_SUCCESS,
  USER_ID_TODO_TIME_FAIL,
  USER_ID_TODO_TIME_REQUEST,
  USER_ID_TODO_TIME_SUCCESS,
  USER_ID_PREV_COMPLETED_TODO_FAIL,
  USER_ID_PREV_COMPLETED_TODO_REQUEST,
  USER_ID_PREV_COMPLETED_TODO_SUCCESS,
  USER_ID_TODAY_COMPLETED_TODO_FAIL,
  USER_ID_TODAY_COMPLETED_TODO_REQUEST,
  USER_ID_TODAY_COMPLETED_TODO_SUCCESS,
  USER_ID_MONTH_TODO_TIME_FAIL,
  USER_ID_MONTH_TODO_TIME_REQUEST,
  USER_ID_MONTH_TODO_TIME_SUCCESS,
  USER_ID_ALL_COMPLETE_TODO_FAIL,
  USER_ID_ALL_COMPLETE_TODO_REQUEST,
  USER_ID_ALL_COMPLETE_TODO_SUCCESS,
  USER_ID_ALL_INCOMPLETE_TODO_FAIL,
  USER_ID_ALL_INCOMPLETE_TODO_REQUEST,
  USER_ID_ALL_INCOMPLETE_TODO_SUCCESS,
  USER_ID_ALL_TODO_TIME_FAIL,
  USER_ID_ALL_TODO_TIME_REQUEST,
  USER_ID_ALL_TODO_TIME_SUCCESS,
  USER_ID_COMPLETE_ALL_TODO_FAIL,
  USER_ID_COMPLETE_ALL_TODO_REQUEST,
  USER_ID_COMPLETE_ALL_TODO_SUCCESS,
  USER_ID_INCOMPLETE_ALL_TODO_FAIL,
  USER_ID_INCOMPLETE_ALL_TODO_REQUEST,
  USER_ID_INCOMPLETE_ALL_TODO_SUCCESS,
  USER_ID_RANGE_TODO_TIME_FAIL,
  USER_ID_RANGE_TODO_TIME_REQUEST,
  USER_ID_RANGE_TODO_TIME_SUCCESS,
} from '../../types/admin/todoType';

export const todoTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_TODO_TIME_REQUEST:
      return {
        ...state,
        Loading: true,
      };
    case USER_ID_TODO_TIME_SUCCESS:
      return {
        ...state,
        Loading: false,
        todoTimerInfo: payload,
        Error: '',
      };
    case USER_ID_TODO_TIME_FAIL:
      return {
        ...state,
        Loading: false,
        todoTimerInfo: [],
        Error: payload,
      };
    default:
      return state;
  }
};

export const todoMothTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_MONTH_TODO_TIME_REQUEST:
      return {
        ...state,
        monthLoading: true,
      };
    case USER_ID_MONTH_TODO_TIME_SUCCESS:
      return {
        ...state,
        monthLoading: false,
        monthTodoTimerInfo: payload,
        monthError: '',
      };
    case USER_ID_MONTH_TODO_TIME_FAIL:
      return {
        ...state,
        monthLoading: false,
        monthTodoTimerInfo: [],
        monthError: payload,
      };
    default:
      return state;
  }
};

export const todoRangeTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_RANGE_TODO_TIME_REQUEST:
      return {
        ...state,
        rangeLoading: true,
      };
    case USER_ID_RANGE_TODO_TIME_SUCCESS:
      return {
        ...state,
        rangeLoading: false,
        rangeTodoTimerInfo: payload,
        rangeError: '',
      };
    case USER_ID_RANGE_TODO_TIME_FAIL:
      return {
        ...state,
        rangeLoading: false,
        rangeTodoTimerInfo: [],
        rangeError: payload,
      };
    default:
      return state;
  }
};

export const todoReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_TODO_REQUEST:
      return {
        ...state,
        todoLoading: true,
      };
    case USER_ID_TODO_SUCCESS:
      return {
        ...state,
        todoLoading: false,
        todoInfo: payload,
        todoError: '',
      };
    case USER_ID_TODO_FAIL:
      return {
        ...state,
        todoLoading: false,
        todoTimerInfo: [],
        todoError: payload,
      };
    default:
      return state;
  }
};

export const todoCompleteReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_ALL_COMPLETE_TODO_REQUEST:
      return {
        ...state,
        todoAllCompleteLoading: true,
      };
    case USER_ID_ALL_COMPLETE_TODO_SUCCESS:
      return {
        ...state,
        todoAllCompleteLoading: false,
        todoAllCompleteInfo: payload,
        todoAllCompleteError: '',
      };
    case USER_ID_ALL_COMPLETE_TODO_FAIL:
      return {
        ...state,
        todoAllCompleteLoading: false,
        todoAllCompleteInfo: [],
        todoAllCompleteError: payload,
      };
    default:
      return state;
  }
};

export const todoInCompleteReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_ALL_INCOMPLETE_TODO_REQUEST:
      return {
        ...state,
        todoAllInCompleteLoading: true,
      };
    case USER_ID_ALL_INCOMPLETE_TODO_SUCCESS:
      return {
        ...state,
        todoAllInCompleteLoading: false,
        todoAllInCompleteInfo: payload,
        todoAllInCompleteError: '',
      };
    case USER_ID_ALL_INCOMPLETE_TODO_FAIL:
      return {
        ...state,
        todoAllInCompleteLoading: false,
        todoAllInCompleteInfo: [],
        todoAllInCompleteError: payload,
      };
    default:
      return state;
  }
};

export const todayTodoCompletedReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_TODAY_COMPLETED_TODO_REQUEST:
      return {
        ...state,
        todayTodoLoading: true,
      };
    case USER_ID_TODAY_COMPLETED_TODO_SUCCESS:
      return {
        ...state,
        todayTodoLoading: false,
        todayTodoInfo: payload,
        todayTodoError: '',
      };
    case USER_ID_TODAY_COMPLETED_TODO_FAIL:
      return {
        ...state,
        todayTodoLoading: false,
        todayTodoInfo: [],
        todayTodoError: payload,
      };
    default:
      return state;
  }
};

export const prevTodoCompletedReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_PREV_COMPLETED_TODO_REQUEST:
      return {
        ...state,
        prevTodoLoading: true,
      };
    case USER_ID_PREV_COMPLETED_TODO_SUCCESS:
      return {
        ...state,
        prevTodoLoading: false,
        prevTodoInfo: payload,
        prevTodoError: '',
      };
    case USER_ID_PREV_COMPLETED_TODO_FAIL:
      return {
        ...state,
        prevTodoLoading: false,
        prevTodoInfo: [],
        prevTodoError: payload,
      };
    default:
      return state;
  }
};

export const todoUserIdAllCompleteReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_COMPLETE_ALL_TODO_REQUEST:
      return {
        ...state,
        todoUserIdCompLoading: true,
      };
    case USER_ID_COMPLETE_ALL_TODO_SUCCESS:
      return {
        ...state,
        todoUserIdCompLoading: false,
        todoUserIdCompInfo: payload,
        todoUserIdCompError: '',
      };
    case USER_ID_COMPLETE_ALL_TODO_FAIL:
      return {
        ...state,
        todoUserIdCompLoading: false,
        todoUserIdCompInfo: [],
        todoUserIdCompError: payload,
      };
    default:
      return state;
  }
};

export const todoUserIdAllInCompleteReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_INCOMPLETE_ALL_TODO_REQUEST:
      return {
        ...state,
        todoUserIdInCompLoading: true,
      };
    case USER_ID_INCOMPLETE_ALL_TODO_SUCCESS:
      return {
        ...state,
        todoUserIdInCompLoading: false,
        todoUserIdInCompInfo: payload,
        todoUserIdInCompError: '',
      };
    case USER_ID_INCOMPLETE_ALL_TODO_FAIL:
      return {
        ...state,
        todoUserIdInCompLoading: false,
        todoUserIdInCompInfo: [],
        todoUserIdInCompError: payload,
      };
    default:
      return state;
  }
};

export const todoTimeUserIdAllReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_ALL_TODO_TIME_REQUEST:
      return {
        ...state,
        todoTimeUserIdLoading: true,
      };
    case USER_ID_ALL_TODO_TIME_SUCCESS:
      return {
        ...state,
        todoTimeUserIdLoading: false,
        todoTimeUserIdInfo: payload,
        todoTimeUserIdError: '',
      };
    case USER_ID_ALL_TODO_TIME_FAIL:
      return {
        ...state,
        todoTimeUserIdLoading: false,
        todoTimeUserIdInfo: [],
        todoTimeUserIdError: payload,
      };
    default:
      return state;
  }
};
